import { useState } from "react";
import AdminModal from "../../../core/admin/adminModal";
import { IVideo } from "./adminHomeConfigs";
import { addDoc, collection, doc, updateDoc } from "firebase/firestore";
import { db } from "../../../../firebase";
import { getURLParams } from "../../../../utils/functions";
import AdminButton from "../../../core/admin/adminButton";
import AdminField, { AdminTextarea } from "../../../core/admin/adminField";
import AdminTextInput from "../../../core/admin/adminTextInput";
import AdminCallout from "../../../core/admin/adminCallout";

export default function ConfigVideoModal({ close, video, refresh, goodToast, badToast }: { close: () => void, video: IVideo | null, refresh: () => void, goodToast: () => void, badToast: () => void }) {

    const [link, setLink] = useState(video?.link || "");
    const [description, setDescription] = useState(video?.description || "");
    const [title, setTitle] = useState(video?.title || "");
    const [preview, setPreview] = useState(false);
    const [videoId, setVideoId] = useState("");
    const [loading, setLoading] = useState(false);

    const saveVideo = async () => {
        try {
            if (!link || !description) {
                return null;
            }
            setLoading(true);
            setPreview(false);
            if (!video) {
                await addDoc(collection(db, "videos"), {
                    link,
                    title,
                    description,
                    active: false
                })
                setLoading(false);
                refresh();
                goodToast();
                close();
                return null;
            }

            const docRef = doc(db, "videos", video.id);
            await updateDoc(docRef, { link, title, description });
            setLoading(false);
            refresh();
            goodToast();
            close();
            return true;
        } catch (error) {
            console.log(error);
            badToast();
            setLoading(false);
            return null;
        }
    }

    const previewVideo = () => {
        setVideoId(getURLParams(link)?.v);
        setPreview(true);
    }

    const isDisabled = (link === video?.link && description === video?.description && video?.title === title ) || link === "" || description === "";

    return (
        <AdminModal
            close={close}
            size="lg"
            title="Configuração do vídeo"
            subtitle="Visualize o vídeo antes de salvar."
            footer={
                <>
                    <AdminButton variant="secondary" disabled={loading} onClick={close}>Cancelar</AdminButton>
                    {
                        preview ?
                            <AdminButton loading={loading} onClick={saveVideo} disabled={isDisabled} className="sm:min-w-[120px]">Salvar</AdminButton>
                            : <AdminButton onClick={previewVideo} disabled={isDisabled}>Visualizar</AdminButton>
                    }
                </>
            }
        >
            <div className="flex flex-col gap-4">
                <AdminField label="Link" htmlFor="video-link" required hint="Link do YouTube no formato youtube.com/watch?v=...">
                    <AdminTextInput id="video-link" inputMode="url" value={link} onChange={e => { setLink(e.target.value); setPreview(false); }} placeholder="https://www.youtube.com/watch?v=" />
                </AdminField>
                <AdminField label="Título" htmlFor="video-title">
                    <AdminTextInput id="video-title" value={title} onChange={e => setTitle(e.target.value)} />
                </AdminField>
                <AdminField label="Descrição" htmlFor="video-description" required>
                    <AdminTextarea id="video-description" value={description} onChange={e => setDescription(e.target.value)} />
                </AdminField>

                {
                    preview ?
                        <div>
                            <h3 className="text-sm font-semibold text-gray-700 mb-2">Pré-visualização</h3>
                            {
                                videoId ?
                                    <div className="aspect-video w-full overflow-hidden rounded-xl bg-gray-950">
                                        <iframe
                                            className="h-full w-full"
                                            src={`https://www.youtube.com/embed/${videoId}`} //?si=1vb3Or9oOKrGmx_q
                                            title="YouTube video player"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                            referrerPolicy="strict-origin-when-cross-origin"
                                            allowFullScreen>
                                        </iframe>
                                    </div>
                                    : <AdminCallout tone="warning">Não foi possível identificar o vídeo neste link. Confira se ele está no formato youtube.com/watch?v=...</AdminCallout>
                            }
                        </div>
                        : null
                }
            </div>
        </AdminModal>
    )
}
